import { IAgent } from "./agent";
import { IBoar } from "./boar";
import { ICenter } from "./center";
import { IParameter } from "./parameter";
import { IProductionSamplingEvent } from "./productionSamplingEvent";
import { IProductionAnalyse } from "./productionAnalyse";
import { IProductionDilutorBath } from "./productionDilutorBath";
import { IProductionSample } from "./productionSample";
import { IProductionStatic } from "./productionStatic";
import { ITraceable } from "./_traceable";

enum StateOfProduction {
    IsWaiting = 0, // En attente, production pas fini - par exemple pas d'observations
    Compliant = 1, // Conformes
    NotCompliant = 2, // Caractéristiques pas bonnes, Non conforme
    Destroyed = 3 // Détruit
}

enum StateOfSampling {
    Clean = 0, // Pure / Brut
    PreDilutedOneByOne = 1, // Prédilution 1 pour 1
    PreDiluted = 2, // Prédilution
    Diluted = 3 // Dilué
}

interface IProduction extends ITraceable {
    // Zone Production
    centerId: number;
    center:ICenter;
    dateProduction: Date;
    observations: string;

    // Zone Animal
    animalId: number;
    animal: IBoar;

    // Zone Agent
    agentDilutorId: number;
    agentDilutor: IAgent;
    agentSamplerId: number;
    agentSampler: IAgent;
    techniqueId: number;
    technique: IParameter;
    nbrEtiquettes: number;
    numberProduction: number;
    numberDayProduction: number;
    blankSample: boolean;
    internalKey? : string;
    // Zone des événements
    samplingEvents : IProductionSamplingEvent[];
    //analyses : IProductionAnalyse[];
    dilutorBaths : IProductionDilutorBath[];
    sample : IProductionSample;
    static : IProductionStatic;

    // Etat Production et Prélevement
    productionState : StateOfProduction;
    samplingState : StateOfSampling;
}

export type { IProduction };
export { StateOfProduction, StateOfSampling }
